import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

//jQuery initialization
import $ from "jquery";

//functions
import {
  _t,
  managePageHrefLink,
  managePageHrefLinkMobile,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

const ReportSidebar = () => {
  const { t } = useTranslation();
  useEffect(() => {
    handleJquery();
  }, []);

  //jQuery goes here
  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
    });
  };

  return (
    <>
      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            <div className="fk-sm-nav" data-simplebar>
              <ul className="t-list fk-sm-nav__bar flex-row">
                {/* dashboard */}
                {managePageHrefLinkMobile(
                  "/dashboard/reports",
                  _t(t("Dashboard"))
                )}

                {/* daily */}
                {managePageHrefLinkMobile(
                  "/dashboard/daily-reports",
                  _t(t("Daily"))
                )}

                {/* monthly */}
                {managePageHrefLinkMobile(
                  "/dashboard/monthly-reports",
                  _t(t("Monthly"))
                )}

                {/* yearly */}
                {/* {managePageHrefLink(
                  "/dashboard/yearly-reports",
                  _t(t("Yearly"))
                )} */}

                {/* food item wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/food-items-reports",
                  _t(t("Item Wise"))
                )}

                {/* food group wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/food-group-reports",
                  _t(t("Group Wise"))
                )}

                {/* branch wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/branch-reports",
                  _t(t("Branch Wise"))
                )}

                {/* pos user wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/pos-user-reports",
                  _t(t("Pos User Wise"))
                )}

                {/* food item wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/dept-tag-reports",
                  _t(t("Department Wise"))
                )}

                {/* Service charge wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/service-charge-reports",
                  _t(t("Service Charge Wise"))
                )}

                {/* discount charge wise */}
                {managePageHrefLinkMobile(
                  "/dashboard/discount-reports",
                  _t(t("discount Wise"))
                )}
                 {managePageHrefLinkMobile(
                  "/dashboard/box-reports",
                  _t(t("Reporte de cajas"))
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation for Small Screen  End*/}

      {/* Navigation for large Screen  */}
      <div className="d-none d-lg-block">
        <div className="fk-scroll--pos-menu" data-simplebar>
          <ul className="t-list fk-pos-nav">
            {/* Foods */}
            <li className={`fk-pos-nav__list fk-pos-nav__list-has-sub active`}>
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Sale's Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
                {/* dashboard */}
                {managePageHrefLink("/dashboard/reports", _t(t("Panel")))}

                {/* daily */}
                {managePageHrefLink("/dashboard/daily-reports", _t(t("Ventas Diarias")))}

                {/* monthly */}
                {managePageHrefLink(
                  "/dashboard/monthly-reports",
                  _t(t("Ventas Mensuales"))
                )}

                {/* yearly */}
                {/* {managePageHrefLink(
                  "/dashboard/yearly-reports",
                  _t(t("Yearly"))
                )} */}

                {/* food item wise */}
                {managePageHrefLink(
                  "/dashboard/food-items-reports",
                  _t(t("Platillos Vendidos"))
                )}

                {/* food group wise */}
                {managePageHrefLink(
                  "/dashboard/food-group-reports",
                  _t(t("Grupo de Platillos"))
                )}

                {/* branch wise */}
                {managePageHrefLink(
                  "/dashboard/branch-reports",
                  _t(t("Local"))
                )}

                {/* pos user wise */}
                {managePageHrefLink(
                  "/dashboard/pos-user-reports",
                  _t(t("Ventas por Usuarios"))
                )}

                {/* food item wise */}
                {/*managePageHrefLink(
                  "/dashboard/dept-tag-reports",
                  _t(t("Department Wise"))
                )*/}

                {/* Service charge wise */}
                {/*managePageHrefLink(
                  "/dashboard/service-charge-reports",
                  _t(t("Ser Charge Wise"))
                )*/}

                {/* discount charge wise */}
                {/*managePageHrefLink(
                  "/dashboard/discount-reports",
                  _t(t("discount Wise"))
                )*/}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/canceled-orders",
                  _t(t("Ordenes Canceladas"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/orders-liquidated",
                  _t(t("Reporte de Ordenes"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/purchase-report",
                  _t(t("Reporte de Compras"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/wasted-reports",
                  _t(t("Reporte Desperdicios"))
                )}
                {managePageHrefLink(
                  "/dashboard/wasted-user",
                  _t(t("Reporte Desperdicio Usuarios"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/gastos-reports",
                  _t(t("Reporte Gastos"))
                )}
                {/* discount charge wise */}

                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/inventorio-bajo",
                  _t(t("Inventario bajo"))
                )}
                {/* discount charge wise */}

                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/report-inventory",
                  _t(t("Inventario"))
                )}
                {/* discount charge wise */}

                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/result",
                  _t(t("Estado de Resultado"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/propinas",
                  _t(t("Propinas"))
                )}
                {/* discount charge wise */}
                {managePageHrefLink(
                  "/dashboard/Cuentasclient-reports",
                  _t(t("Cuentas Clientes"))
                )}

                {managePageHrefLink(
                  "/dashboard/Ingredientcost-reports",
                  _t(t("Costo de Ingredientes"))
                )}

                {managePageHrefLink(
                  "/dashboard/visitas-reports",
                  _t(t("Visitas de Clientes"))
                )}
                {managePageHrefLink(
                  "/dashboard/box-reports",
                  _t(t("Reporte de Cajas"))
                )}
              </ul>
            </li>
          </ul>
        </div>
      </div>
      {/* Navigation for large Screen End */}
    </>
  );
};

export default ReportSidebar;
